<template>
    <v-container fluid>
        <v-flex>
            <v-card
                width="256"
                fill-height
                xs2
            >
                <Drawer/>
            </v-card>
        </v-flex>
        <v-flex xs12 ma-0 pa-0>
            <v-container ma-0 pa-0 fluid>
                <ContactIterator/>
            </v-container>
        </v-flex>
    <TagForm/>
    <TagDeleteForm/>
    <DetailsDialog/>
    <DeleteContact/>
    <ContactForm/>
    <ImportForm/>
    </v-container>
</template>
<script>
import Drawer from '@/components/contacts/drawer/index'
import TagForm from '@/components/contacts/forms/tag'
import ContactForm from '@/components/contacts/forms/contact_dialog'
import DeleteContact from '@/components/contacts/forms/delete_contact'
import TagDeleteForm from '@/components/contacts/forms/delete_tag'
import ImportForm from '@/components/contacts/forms/import'
import ContactIterator from '@/components/contacts/contact_iterator'
import DetailsDialog from '@/components/contacts/details_dialog'
export default {
  name: 'contacts-index',
  components: {
    Drawer,
    ContactIterator,
    TagForm,
    TagDeleteForm,
    DetailsDialog,
    DeleteContact,
    ImportForm,
    ContactForm
  }
}
</script>

<style>
</style>
